import { useEffect, useState, useMemo } from 'react';
import { Input } from '../../../common/Forms/Input/Input';
import { set, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as schemas from '../../../../assets/schemas/schemas';
import { ActionButton } from '../../../common/Buttons/Buttons';
import {
  campaignActionOptions,
  paymentType,
  rcvEnum,
  KMOderOptions,
  LEGACY_PLAN_KM,
  getPlanBaseKm,
  getDefaultPlanKm,
  planAllowsUnlimitedTow,
  getUnlimitedTowLabel,
  isNewPlanRulesActive,
  rcvOptions,
  planStatus,
  membershipCodes,
  userType,
  planTypes,
  affiliationType,
} from '../../../../assets/helpers/options';
import { usersService } from '../../../../services/usersService';
import { saleChannelService } from '../../../../services/saleChannelService';
import { membershipService } from '../../../../services/membershipService';
import { paymentsService } from '../../../../services/paymentsService';
import { rateService } from '../../../../services/rateService';
import { productService } from '../../../../services/productService';
import { membershipCatalogService } from '../../../../services/membershipCatalogService';
import { currencyRateService } from '../../../../services/currencyRateService';
import { notify } from '../../../../assets/helpers/toast';
import {
  filterParams,
  getCorrectDate,
  defineLangindType,
  filterById,
  parseUrl,
  displayMembershipCode,
} from '../../../../assets/helpers/funciones';
import { LoadSpinner } from '../../../common/LoadSpinner/LoadSpinner';
import { OderCardHeader } from './OrderComponents';
import { getPaymentTypeOptions } from './affiliationPaymentTypes';
import authService from '../../../../services/authService';
import { salesRoles } from '../../../../assets/helpers/roles';
import moment from 'moment';
import './OrderComponent.scss';
import { useHistory } from 'react-router-dom';
import { TransferToIntermediaryModal } from './TransferToIntermediaryModal';
import { IntermediaryTransferTrigger } from './IntermediaryTransferTrigger';

const allowAdmin = () => {
  if ([salesRoles.SALES_ADMIN].includes(authService?.getUserType())) {
    return false;
  } else {
    return true;
  }
};

const allowEditPayment = () => {
  if (
    [salesRoles.SALES_ADMIN, salesRoles?.SALES_ADMIN_AUX].includes(
      authService?.getUserType()
    )
  ) {
    return false;
  } else {
    return true;
  }
};

export const AfiliationCard = (props) => {
  const { label, membership, reloadMembership } = props;
  const user = authService.getUser();
  const [open, setOpen] = useState(true);
  const [sellerOptions, setSellerOptions] = useState([]);
  const [externalSellerOptions, setExternalSellerOptions] = useState([]);

  const [salesChannelOptions, setSalesChannelOptions] = useState([]);
  const [dollarRate, setDollarRate] = useState('');
  const [paymentDateRate, setPaymentDateRate] = useState('');
  const [bsDisabled, setbsDisabled] = useState(true);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [filteredMethods, setFilteredMethods] = useState([]);
  const [showIntermediaryModal, setShowIntermediaryModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [membershipOptions, setMembershipOptions] = useState([]);
  // Se recalcula desde la lista completa al cambiar el estado de la orden
  // (p. ej. al reactivarla), para que Cashea vuelva a aparecer si aplica.
  const allPaymentTypesOptions = useMemo(
    () =>
      getPaymentTypeOptions({
        role: authService?.getUserType(),
        userType: authService?.getUser()?.type,
        membershipStatus: membership?.membershipStatus,
      }),
    [membership?.membershipStatus]
  );
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    control,
  } = useForm({
    resolver: yupResolver(schemas.updateMembershipForm()),
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setValue: setValue2,
    watch: watch2,
    control: control2,
  } = useForm({
    resolver: yupResolver(schemas.updatePaymentForm()),
    defaultValues: {
      paymentDate: moment(new Date())?.format('YYYY-MM-DD'), // Initialize with specific value
    },
  });

  const transferTo = watch('transferTo');


  const clearTransferTo = () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    membershipService
      .updateTransferTo(membership?._id, { transferTo: null })
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          notify(`Intermediario removido`, 'success');
          setValue('transferTo', null, {
            shouldDirty: true,
            shouldValidate: true,
          });
          reloadMembership();
        } else {
          notify(`${response?.message || 'Error al remover intermediario'}`, 'error');
        }
      })
      .catch(() => {
        notify(`Error al remover intermediario`, 'error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const confirmTransferToIntermediary = async () => {
    const transferTo = watch('transferTo');
    if (!transferTo || isLoading) {
      return;
    }

    setIsLoading(true);
    membershipService
      .updateTransferTo(membership?._id, { transferTo })
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          notify(`Intermediario asignado`, 'success');
          setShowIntermediaryModal(false);
          reloadMembership();
        } else {
          notify(`${response?.message || 'Error al actualizar intermediario'}`, 'error');
        }
      })
      .catch(() => {
        notify(`Error al actualizar intermediario`, 'error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const preloadForm = () => {
    // DATOS DEL PLAN
    setValue('affiliationType', membership?.affiliationType);
    setValue('contractType', membership?.contractType);
    setValue('campaignAction', membership?.campaignAction);
    // FECHAS ASOCIADAS
    setValue(
      'createdAt',
      membership?.createdAt ? getCorrectDate(membership?.createdAt) : ''
    );
    setValue('comment', membership?.comment);
    setValue(
      'beginDate',
      membership?.beginDate ? getCorrectDate(membership?.beginDate) : ''
    );
    setValue(
      'rcvEmissionDate',
      membership?.beginDate ? getCorrectDate(membership?.rcvEmissionDate) : ''
    );
    setValue(
      'endDate',
      membership?.endDate ? getCorrectDate(membership?.endDate) : ''
    );
    setValue(
      'rcvBeginDate',
      membership?.rcvBeginDate ? getCorrectDate(membership?.rcvBeginDate) : ''
    );
    setValue('useMedCert', membership?.hasMedCert);
    setValue(
      'rcvEndDate',
      membership?.rcvEndDate ? getCorrectDate(membership?.rcvEndDate) : ''
    );

    if (membership?.hasRcvCard) {
      setValue('hasRcvCard', membership?.hasRcvCard);
    } else {
      setValue('hasRcvCard', false);
      setValue('code', false);
    }
    setValue('transferTo', membership?.transferTo || '');

    if (membership?.endDateFromLastMembership) {
      setValue(
        'endDateFromLastMembership',
        membership?.endDateFromLastMembership
          ? getCorrectDate(membership?.endDateFromLastMembership)
          : ''
      );
    }
    if (membership?.rcvEndDateFromLastMembership) {
      setValue(
        'rcvEndDateFromLastMembership',
        membership?.rcvEndDateFromLastMembership
          ? getCorrectDate(membership?.rcvEndDateFromLastMembership)
          : ''
      );
    }
    // DATOS DEL PAGO
    if (membership?.membershipStatus !== 'INCOMPLETO') {
      setValue2('discountCode', membership?.discountCode);
      setValue2(
        'discountByCode',
        membership?.priceInfo?.discountByCode
          ? membership?.priceInfo?.discountByCode + ' $'
          : ''
      );

      setValue2('giftcardCode', membership?.giftcardCode);
      setValue2(
        'discountByGiftcard',
        membership?.priceInfo?.discountByGiftcard
          ? membership?.priceInfo?.discountByGiftcard + ' $'
          : ''
      );
    }

    setValue2('paymentStatus', membership?.paymentStatus);
    setValue2(
      'finalPrice',
      parseFloat(membership?.priceInfo?.finalPrice?.toFixed(2))
    );
    setValue2(
      'finalPriceInBsS',
      parseFloat(membership?.priceInfo?.finalPriceInBsS?.toFixed(2))
    );
    setValue2('paymentType', membership?.paymentType);

    if (membership?.discountCode) {
      setValue2('code', membership?.discountCode);
      setValue2('discountCode', membership?.discountCode);
      setValue2(
        'discountByCode',
        membership?.priceInfo?.discountByCode
          ? membership?.priceInfo?.discountByCode + ' $'
          : ''
      );
    }

    if (membership?.giftcardCode) {
      setValue2('giftcardCode', membership?.giftcardCode);
      setValue2(
        'discountByGiftcard',
        membership?.priceInfo?.discountByGiftcard
          ? membership?.priceInfo?.discountByGiftcard + ' $'
          : ''
      );
    }

    setValue2('paymentMethodsQuantity', membership?.payments?.length);
    if (membership?.membershipStatus === 'INCOMPLETO') {
      setValue2('paymentMethodsQuantity', 1);
    }

    if (membership?.payments?.length > 0) {
      for (let i = 0; i < membership?.payments?.length; i++) {
        setValue2(`paymentAmount${i}`, membership?.payments[i]?.totalAmount);
        setValue2(
          `paymentAmountBsS${i}`,
          membership?.payments[i]?.totalAmountInBsS?.toFixed(2)
        );
        Promise.allSettled([getPaymentMethods()]).then((r) => {
          setTimeout(() => {
            setValue2(`paymentMethod${i}`, membership?.payments[i]?.methodId);
          }, 2500);
        });
        setValue2(`paymentMethod${i}`, membership?.payments[i]?.methodId);
        setValue2(`paymentReference${i}`, membership?.payments[i]?.reference);
      }
    }

    if (membership?.km) {
      setValue('km', membership?.km);
      setValue('useExtendedTow', membership?.hasExtendedTow);
    }

    if ([planTypes?.F2]?.includes(membership?.membershipPlan)) {
      setValue('km', 10);
    }

    if ([planTypes?.CLASSIC]?.includes(membership?.membershipPlan)) {
      setValue('km', 25);
    }
    if (
      [planTypes?.PLUS, planTypes?.PLUSM]?.includes(
        membership?.membershipPlan
      ) &&
      (isNewPlanRulesActive(membership?.createdAt) ||
        membership?.membershipPlan === planTypes?.PLUS)
    ) {
      // Nuevas condiciones: se muestra el km contratado; si no viene, la cobertura base (100).
      // Condiciones anteriores: Plus siempre 50.
      setValue(
        'km',
        isNewPlanRulesActive(membership?.createdAt)
          ? membership?.km ||
          getPlanBaseKm(membership?.membershipPlan, membership?.createdAt)
          : 50
      );
    }

    if ([planTypes?.PLUSF4, planTypes?.BERA]?.includes(membership?.membershipPlan)) {
      setValue('km', 50);
    }

    if (
      [planTypes?.GOLD, planTypes?.GOLDM]?.includes(membership?.membershipPlan)
    ) {
      if (membership?.km) {
        setValue('km', membership?.km);
      } else {
        setValue(
          'km',
          getPlanBaseKm(membership?.membershipPlan, membership?.createdAt)
        );
      }
    }

    Promise.allSettled([
      getUsers(),
      getSalesChannel(),
      getAvailableMemberships(),
    ]).then((r) => {
      setTimeout(() => {
        setValue('rcv', membership?.rcv ? membership?.rcv : rcvEnum?.NA);
      }, 2500);
    });

    if (membership?.paymentType === paymentType?.FINANCIADO) {
      Promise.allSettled([getPaymentMethods(), getDollarRate()]).then((r) => {
        setTimeout(() => {
          for (let i = 0; i < membership?.paymentDues?.length; i++) {
            let [selectedPayment] = membership?.payments?.filter(
              (p) => p?._id === membership?.paymentDues[i]?.payment[0]
            );

            if (selectedPayment) {
              setValue2(
                `paymentDues[${i}].amount`,
                selectedPayment.totalAmount
              );
              setValue2(
                `paymentDues[${i}].amountBs`,
                selectedPayment.totalAmountInBsS?.toFixed(2)
              );
              setValue2(
                `paymentDues[${i}].reference`,
                selectedPayment.reference
              );
              setValue2(
                `paymentDues[${i}].paymentMethod`,
                selectedPayment?.methodId
              );
            } else {
              setValue2(
                `paymentDues[${i}].amount`,
                membership?.paymentDues[i]?.amount?.toFixed(2)
              );
              setValue2(
                `paymentDues[${i}].amountBs`,
                (membership?.paymentDues[i]?.amount * dollarRate)?.toFixed(2)
              );
              setValue2(
                `paymentDues[${i}].paymentMethod`,
                membership?.paymentDues[i]?.paymentMethod
              );
            }

            if (selectedPayment?.length > 0) {
              setValue2(
                `paymentDues[${i}].reference`,
                selectedPayment[0]?.reference
              );
            }

            setValue2(
              `paymentDues[${i}].payment`,
              membership?.paymentDues[i]?.payment[0]
                ? 'Pago realizado'
                : 'Cuenta por cobrar'
              //Aqui colocar iuna funcion que ponga el estatus 'Pago realizado', 'Cuenta por cobrar' o pago vencido dependiendo de la fecha del pago
            );

            setValue2(
              `paymentDues[${i}].paymentDate`,
              membership?.paymentDues[i]?.paymentDate
                ? moment(membership?.paymentDues[i]?.paymentDate).format(
                  'DD/MM/YYYY'
                )
                : ''
            );
            setValue2(
              `paymentDues[${i}].dueDate`,
              membership?.paymentDues[i]?.dueDate
                ? moment(membership?.paymentDues[i]?.dueDate).format(
                  'DD/MM/YYYY'
                )
                : ''
            );
          }
        }, 1500);
      });
    }
  };

  const specialPayment = () => {
    const formData = new FormData();
    formData.append('paymentType', watch2('paymentType'));
    formData.append('membership', membership?._id);
    if (!isLoading) {
      setIsLoading(true);
      paymentsService
        .createMembershipPayment(formData)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Pago registrado con exito`, 'success');
            window.location.reload();
          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.error('error', error);
          notify(`Error al registrar el pago`, 'error');
          setIsLoading(false);
        });
    }
  };

  const filterPlanType = (plans) => {
    if ([planTypes?.PLUSF4]?.includes(membership?.membershipPlan)) {
      plans = plans?.filter(
        (p) =>
          ![membershipCodes?.FREE, membershipCodes?.MOTORIDERAV].includes(
            p?.code
          )
      );
      return plans;
    }

    if ([planStatus?.INCOMPLETED].includes(membership?.membershipStatus)) {
      plans = plans?.filter(
        (p) =>
          ![
            membershipCodes?.FREE,
            membershipCodes?.RCV,
            membershipCodes?.RCV_ELITE,
          ].includes(p?.code)
      );
      return plans;
    } else return plans;
  };

  // Fecha con la que se evalúan las políticas de planes: la fecha de creación
  // editada en el formulario o, si no hay, la de la membresía
  const getRulesDate = () => watch('createdAt') || membership?.createdAt;

  const filterKmOptions = (options) => {
    let [filteredOptions] = membershipOptions?.filter(
      (o) => o?._id === watch('code')
    );

    let km = watch('km');

    if ([planTypes?.F2]?.includes(filteredOptions?.code)) {
      return options?.filter((o) => [10]?.includes(o?._id));
    }

    if ([planTypes?.CLASSIC]?.includes(filteredOptions?.code)) {
      return options?.filter((o) => [25]?.includes(o?._id));
    }
    if ([planTypes?.PLUSF4, planTypes?.BERA]?.includes(filteredOptions?.code)) {
      return options?.filter((o) => [50]?.includes(o?._id));
    }
    const rulesDate = getRulesDate();
    if (
      [planTypes?.PLUS, planTypes?.PLUSM]?.includes(filteredOptions?.code) &&
      (isNewPlanRulesActive(rulesDate) ||
        filteredOptions?.code === planTypes?.PLUS)
    ) {
      // Cobertura vigente 100 km; se conserva el km actual si es distinto (membresía existente)
      const allowed = isNewPlanRulesActive(rulesDate)
        ? [getPlanBaseKm(filteredOptions?.code, rulesDate), Number(km)]
        : [50];
      return options?.filter((o) => allowed.includes(o?._id));
    }
    if ([planTypes?.GOLD, planTypes?.GOLDM]?.includes(filteredOptions?.code)) {
      if (!isNewPlanRulesActive(rulesDate)) {
        return options?.filter((o) => [200, 300]?.includes(o?._id));
      }
      // Cobertura vigente 400 km; el km contratado (ej. 200/300) solo se
      // mantiene visible en membresías existentes que ya lo tienen
      const allowed = [
        getPlanBaseKm(filteredOptions?.code, rulesDate),
        Number(km),
      ];
      if (LEGACY_PLAN_KM.includes(Number(membership?.km))) {
        allowed.push(Number(membership?.km));
      }
      return options?.filter((o) => allowed.includes(o?._id));
    }
    if (
      [
        planTypes?.MOTORIDER, planTypes?.MOTORIDERAV, planTypes?.FREE, planTypes?.BARATICO,
      ]?.includes(filteredOptions?.code)
    ) {
      return [];
    } else return options;
  };

  const renew = () => {
    let paymentDate = watch2('paymentDate');
    sessionStorage.setItem('paymentDate', paymentDate);
    let url = `/afiliations/payment/${membership?._id}/renewal/${parseUrl(
      watch2('paymentType')
    )}`;
    history.push(url);
  };

  const validateIfCanPay = () => {
    if (membership?.membershipStatus !== 'INCOMPLETO') {
      return null;
    }

    let label = 'Realizar Pago';
    let action = renew;

    // ? para para afiliasiones de cortesia, no hace falta pago
    if (
      [paymentType?.COURTESY].includes(
        watch2('paymentType')
      )
    ) {
      label = `Pago ${watch2('paymentType')}`;
      action = specialPayment;
    }
    // ? diferido queda como cuenta por cobrar, no hace falta pago para renovar
    if (
      [paymentType?.PENDING].includes(
        watch2('paymentType')
      )
    ) {
      label = `Pago ${watch2('paymentType')}`;
      action = specialPayment;
    }



    if (
      watch2('paymentType') &&
      (watch2('finalPrice') || watch2('finalPrice') !== 0) &&
      watch2('finalPriceInBsS') &&
      watch2('paymentMethodsQuantity')
    ) {
      return (
        <div style={{ marginTop: '12px' }} className="buttons-center-container">
          <ActionButton label={label} action={() => action()} />
        </div>
      );
    }
    // Realizar ago
    if (
      watch2('paymentType') &&
      (watch2('finalPrice') || watch2('finalPrice') === 0) &&
      watch2('finalPriceInBsS') &&
      watch2('paymentMethodsQuantity')
    ) {
      action = updateStatus;
      label = 'Realizar Renovación ';
      return (
        <div className="buttons-center-container">
          <ActionButton label={label} action={() => action()} />
        </div>
      );
    } else {
      return null;
    }
  };

  const handleTypeChange = () => {
    const [selectedOption] = membershipOptions?.filter(
      (p) => p?._id === watch('code')
    );
    setTimeout(() => {
      if (selectedOption?.code === planTypes?.CLASSIC) {
        setValue('km', 25);
      }
      if ([planTypes?.PLUSF4, planTypes?.BERA]?.includes(selectedOption?.code)) {
        setValue('km', 50);
      }
      const rulesDate = getRulesDate();
      if (
        [planTypes?.PLUS, planTypes?.PLUSM]?.includes(selectedOption?.code) &&
        (isNewPlanRulesActive(rulesDate) ||
          selectedOption?.code === planTypes?.PLUS)
      ) {
        setValue('km', getPlanBaseKm(selectedOption?.code, rulesDate));
      }
      if ([planTypes?.GOLD, planTypes?.GOLDM].includes(selectedOption?.code)) {
        setValue(
          'km',
          getDefaultPlanKm(selectedOption?.code, membership?.km, rulesDate)
        );
      }
    }, 1000);
  };

  const applyDiscount = handleSubmit2(async (data) => {
    let dataToPost = {
      code: data?.code,
    };

    if (membership?.discountCode) {
      notify(`La membresia ya tiene un descuento aplicado`, 'info');

      return null;
    }

    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .upgradeMembershipPaymet(filterParams(dataToPost), membership?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Código Aplicado`, 'success');
            reloadMembership();
            setIsLoading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const removeDiscount = handleSubmit2(async (data) => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .removeCode(membership?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Código removido`, 'success');
            setValue2('code', '');
            setValue2('discountByCode', '');
            setValue2('giftcardCode', '');
            setValue2('discountByGiftcard', '');
            reloadMembership();
            setIsLoading(false);
            // window.location.reload();
          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const getAvailableMemberships = () => {
    let params = {};

    params = defineLangindType(params, membership);
    params.class = membership?.vehicle?.classId;
    params.year = membership?.vehicle?.year;

    const createdAt = watch('createdAt') || membership?.createdAt;
    if (createdAt) {
      params.rcvEmissionDate = moment(createdAt).format('YYYY-MM-DD');
    }

    membershipCatalogService
      .getAvailableMemberships(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          let data = [...response?.data];

          if (membership?.membershipStatus === planStatus?.INCOMPLETED) {
            data = data?.filter(
              (d) => ![membershipCodes?.FREE]?.includes(d?.code)
            );
          }

          if (membership?.membershipPlan === planTypes?.MOTORIDER) {
            const hasMotorider = data.some(
              (d) => d?.code === membershipCodes?.MOTORIDER
            );
            if (!hasMotorider) {
              data.push({
                _id: membership?.membershipCode,
                code: membershipCodes?.MOTORIDER,
              });
            }
          }

          data = data?.filter(
            (d) =>
              ![membershipCodes?.RCV, membershipCodes?.RCV_ELITE]?.includes(
                d?.code
              )
          );

          for (let i = 0; i < data?.length; i++) {
            data[i].name = displayMembershipCode(data[i]?.code);
          }

          setMembershipOptions(filterPlanType(data));
          if (
            membership?.membershipPlan !== membershipCodes?.FREE ||
            membership?.membershipStatus !== planStatus?.INCOMPLETED
          ) {
            setValue('code', membership?.membershipCode);
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  function dateDiffInDays(firstDate, secondDate) {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const diffDays = Math.round(
      Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
    );
    return diffDays;
  }

  const validateCreatedDate = (dataToPost) => {
    const firstDate = new Date();
    const secondDate = new Date(dataToPost?.createdAt);
    const daysDifference = dateDiffInDays(firstDate, secondDate);

    if (
      [
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.SALES_KEY_ACCOUNTS,
      ].includes(authService.getUserType()) &&
      daysDifference > 5
    ) {
      delete dataToPost?.createdAt;
      return dataToPost;
    } else return dataToPost;
  };

  const editMembership = handleSubmit(async (data) => {
    let dataToPost = { ...data };
    const shouldSendNullTransferTo = dataToPost?.transferTo === null;


    dataToPost = validateCreatedDate(dataToPost);
    // delete dataToPost?.createdAt;
    delete dataToPost?.contractType;
    delete dataToPost?.affiliationType;
    dataToPost = filterParams(dataToPost);
    if (shouldSendNullTransferTo) {
      dataToPost.transferTo = null;
    }

    if (["", null, undefined].includes(dataToPost.comment)) {
      dataToPost.comment = "";
    }

    if (dataToPost.useMedCert === 'true' || dataToPost.useMedCert === true) {
      dataToPost.useMedCert = true;
    } else {
      dataToPost.useMedCert = false;
    }

    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .updateMembership(dataToPost, membership?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            handleCreationDateChange();
            notify(`Datos actualizados`, 'success');
            reloadMembership();
            setIsLoading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const getDollarRate = async () => {
    rateService
      .getDollarRate()
      .then((response) => {
        if (response.status === 200) {
          setDollarRate(response?.data?.rate);
          setbsDisabled(true);

          if (membership?.paymentType === paymentType?.FINANCIADO) {
            setValue2(
              `paymentDues[0].amountBs`,
              (
                response?.data?.rate * membership?.paymentDues[0]?.amount
              )?.toFixed(2)
            );
            setValue2(
              `paymentDues[1].amountBs`,
              (
                response?.data?.rate * membership?.paymentDues[1]?.amount
              )?.toFixed(2)
            );
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const getUsers = async () => {
    let params = {
      limit: 1000000,
      offset: 0,
      module: 'Ventas',
      status: 'Activo',
    };
    usersService
      .getUsers(params)
      .then((response) => {
        if (response.status === 200) {
          let data = [];
          let externalData = [];
          for (let i = 0; i < response?.data?.users?.length; i++) {
            data?.push({
              _id: response?.data?.users[i]?._id,
              name:
                response?.data?.users[i]?.firstName +
                '  ' +
                response?.data?.users[i]?.lastName,
            });
            if (response?.data?.users[i]?.type !== userType?.INTERNO && response?.data?.users[i]?.role === salesRoles?.SALES_COUNTER) {
              externalData?.push({
                _id: response?.data?.users[i]?._id,
                name:
                  response?.data?.users[i]?.firstName +
                  '  ' +
                  response?.data?.users[i]?.lastName,
                type: response?.data?.users[i]?.type,
              });
            }
          }

          setSellerOptions(data);
          setExternalSellerOptions(externalData);
          setValue('seller', membership?.seller);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const getSalesChannel = () => {
    saleChannelService
      .getSalesChannel()
      .then((response) => {
        if (response.status === 200) {
          setSalesChannelOptions(response?.data?.saleChannels);
          setValue('saleChannel', membership?.saleChannel);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods('sales')
      .then((response) => {
        if (response.status === 200) {
          setPaymentMethods(response?.data);

          let filtered = response?.data?.filter((method) =>
            [paymentMethods?.CASHEA]?.includes(method?.name)
          );
          setFilteredMethods(filtered);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const updateStatus = () => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .updateMembershipStatus(membership?._id)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            // notify(`Membresia aprobada`, 'success');
            window.location.reload();
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  };

  const updatePaymentTypeInRenewal = () => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .updatePaymentTypeInRenewal(membership?._id, {
          paymentType: watch2('paymentType'),
        })
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            reloadMembership();
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  };

  const changePaymentType = () => {
    if (
      [
        planStatus.PENDING_FOR_APPROBAL,
        planStatus.WAITING,
        planStatus.TO_BE_EXPIRED,
      ].includes(membership.membershipStatus)
    ) {
      history.push(
        `/afiliations/change-payment/${membership?._id}/${watch2('paymentType')
          .replace(/ /g, '-')
          .toLowerCase()}`
      );
    } else {
      if (watch2('paymentType') === paymentType?.FINANCIADO) {
        setValue2('paymentMethodsQuantity', 1);
      }

      updatePaymentTypeInRenewal();
    }
  };

  const handleBsAmount = () => {
    setValue2(
      'finalPriceInBsS',
      (parseFloat(watch2('finalPrice')) * paymentDateRate)?.toFixed(2)
    );
  };

  useEffect(() => {
    getDollarRate();
    getPaymentMethods();
    getAvailableMemberships();
    preloadForm();
    getPaymentDateRate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, membership]);

  const affiliationOptionsLoaded = useMemo(() => {
    return [salesChannelOptions, membershipOptions, sellerOptions].every(
      (opt) => Array.isArray(opt) && opt.length > 0
    );
  }, [salesChannelOptions, membershipOptions, sellerOptions]);

  const validateDisabled = (inputName) => {
    if (
      ['rcvBeginDate', 'rcvEndDate']?.includes(inputName) &&
      membership?.membershipPlan === planTypes?.PLUSF4
    ) {
      return true;
    }

    if (
      [
        salesRoles.SALES_ADMIN,
        salesRoles?.SALES_DEVELOPER,
        salesRoles?.SALES_SUPERVISOR,
      ].includes(authService.getUserType())
    ) {
      return false;
    }
    if (
      [salesRoles.SALES_ADMIN_AUX].includes(authService.getUserType()) &&
      membership?.membershipStatus === planStatus?.PENDING_FOR_APPROBAL
    ) {
      return false;
    }
    if (
      [
        salesRoles?.SALES_SUPERVISOR,
        salesRoles.SALES_HUNTER,
        salesRoles.SALES_FARMER,
        salesRoles.SALES_KEY_ACCOUNTS,
      ].includes(authService.getUserType()) &&
      [planStatus?.PENDING_FOR_APPROBAL, planStatus?.TO_BE_RENEW].includes(
        membership?.membershipStatus
      )
    ) {
      return false;
    } else return true;
  };

  const determinValidDate = () => {
    // let createdAt = new Date(watch('createdAt'));
    let createdAt = new Date();
    let minDate = createdAt;
    minDate.setDate(minDate.getDate() - 4);

    if (
      [salesRoles?.SALES_ADMIN, salesRoles?.SALES_SUPERVISOR].includes(
        authService.getUserType()
      )
    ) {
      return false;
    }
    if (
      ([
        salesRoles?.SALES_SUPERVISOR,
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.EVENTS,
        salesRoles?.SALES_KEY_ACCOUNTS
      ].includes(authService.getUserType()) &&
        membership?.membershipStatus === planStatus?.PENDING_FOR_APPROBAL) ||
      canEditRenewalTemplate()
    ) {
      return minDate;
    } else return false;
  };

  const isInternalCounter = () =>
    authService.getUserType() === salesRoles.SALES_COUNTER &&
    authService.getUser()?.type === userType.INTERNO;

  // Hunter, farmer y counter interno pueden editar fecha de creación, km
  // y grúa ilimitada mientras la orden sigue en la plantilla de renovación.
  const canEditRenewalTemplate = () => {
    const role = authService.getUserType();
    const allowedRole =
      [salesRoles.SALES_HUNTER, salesRoles.SALES_FARMER].includes(role) ||
      isInternalCounter();

    if (!allowedRole) return false;

    const isRenewalTemplate =
      membership?.affiliationType === affiliationType.RENEW ||
      membership?.membershipStatus === planStatus.TO_BE_RENEW;

    const openRenewalStatus = [
      planStatus.TO_BE_RENEW,
      planStatus.PENDING_FOR_APPROBAL,
      planStatus.INCOMPLETED,
      planStatus.PENDING_DOCUMENTATION,
      planStatus.WAITING,
    ].includes(membership?.membershipStatus);

    return isRenewalTemplate && openRenewalStatus;
  };

  const validateCreationDate = () => {
    if (
      [salesRoles?.SALES_ADMIN, salesRoles?.SALES_SUPERVISOR].includes(
        authService.getUserType()
      )
    ) {
      return false;
    }

    if (canEditRenewalTemplate()) {
      return false;
    }

    if (
      [
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.SALES_KEY_ACCOUNTS,
      ].includes(
        authService.getUserType() &&
        [planStatus?.ACTIVE, planStatus?.TO_BE_RENEW]?.includes(
          membership?.membershipStatus
        )
      )
    ) {
      return true;
    }

    if (
      [
        salesRoles.SALES_ADMIN_AUX,
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.SALES_KEY_ACCOUNTS,
      ].includes(authService.getUserType()) &&
      membership?.membershipStatus === planStatus?.PENDING_FOR_APPROBAL
    ) {
      return false;
    } else return true;
  };

  const handleRCVChange = () => {
    if (watch('rcv') === rcvEnum.NA) {
      setValue('hasRcvCard', false);
    }
  };

  const justRenovation = () => {
    if (membership?.membershipStatus === planStatus?.INCOMPLETED) {
      return true;
    }

    if (membership?.membershipPlan === planTypes?.PLUSF4) {
      return true;
    }

    if (
      [
        salesRoles.SALES_DEVELOPER,
        salesRoles.SALES_ADMIN,
        salesRoles.SALES_SUPERVISOR,
      ].includes(authService.getUserType())
    ) {
      return false;
    } else return true;
  };

  const justAdminAndSupervisor = () => {
    if (
      [salesRoles?.SALES_ADMIN, salesRoles?.SALES_SUPERVISOR]?.includes(
        authService.getUserType()
      )
    ) {
      return false;
    } else {
      return true;
    }
  };

  // const editAllPaymentBs = (rate) => {
  //   const formData = new FormData();

  //   formData.append(`membership`, membership?._id);

  //   for (let i = 0; i < membership?.payments?.length; i++) {
  //     formData.append(`payments[${i}][id]`, membership?.payments[i]?._id);
  //     formData.append(
  //       `payments[${i}][method]`,
  //       membership?.payments[i]?.methodId
  //     );
  //     formData.append(
  //       `payments[${i}][reference]`,
  //       membership?.payments[i]?.reference
  //     );
  //     formData.append(
  //       `payments[${i}][amount]`,
  //       membership?.payments[i]?.totalAmount
  //     );
  //     formData.append(
  //       `payments[${i}][amountBsS]`,
  //       membership?.payments[i]?.totalAmount * rate
  //     );
  //     formData.append(
  //       `payments[${i}][creationDate]`,
  //       membership?.payments[i]?.createdAt
  //     );
  //   }

  //   if (!isLoading && formData) {
  //     setIsLoading(true);
  //     paymentsService
  //       .editPayment(formData)
  //       .then((response) => {
  //         if ([200, 201].includes(response.status)) {
  //           // notify(`Pago editado con exito`, 'success');
  //           reloadMembership();
  //           setIsLoading(false);
  //         } else {
  //           notify(`${response.message}`, 'error');
  //           setIsLoading(false);
  //         }
  //       })
  //       .catch((error) => {
  //         setIsLoading(false);
  //       });
  //   }
  // };

  const validatePlanType = (membershipStatus) => {
    if ([salesRoles.SALES_ADMIN].includes(authService?.getUserType())) {
      return false;
    }
    if (![planStatus?.PENDING_FOR_APPROBAL].includes(membershipStatus)) {
      return true;
    } else return false;
  };

  const getCurrencyRates = () => {
    let createdAt = getCorrectDate(membership?.createdAt);
    let date1 = moment(createdAt).format('YYYY-MM-DD');
    let date2 = moment(watch('createdAt')).format('YYYY-MM-DD');

    if (date1 !== date2) {
      let params = {
        currency: 'USD',
        date: watch('createdAt')
          ? moment(watch('createdAt')).format('YYYY-MM-DD')
          : '',
        limit: 1,
      };

      currencyRateService
        .getCurrencyRates(params)
        .then((response) => {
          if (response.status === 200) {
            let rate = response?.data?.result[0]?.rate;
            // editAllPaymentBs(rate);
          } else {
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch(() => { });
      return true;
    }
  };

  const getPaymentDateRate = () => {
    let params = {
      currency: 'USD',
      date: watch2('paymentDate')
        ? moment(watch2('paymentDate')).format('YYYY-MM-DD')
        : '',
      limit: 1,
    };
    currencyRateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          let rate = response?.data?.result[0]?.rate;
          setPaymentDateRate(rate);

          setValue2(
            'finalPriceInBsS',
            (parseFloat(watch2('finalPrice')) * rate)?.toFixed(2)
          );
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
    return true;
  };

  const handleCreationDateChange = () => {
    getCurrencyRates();
    // La fecha define las políticas de planes: se recalcula el km si cruza el 01/10/2026
    handleTypeChange();
  };

  // Internal counter cant see affiliation cards
  // if (
  //   [salesRoles?.SALES_COUNTER].includes(authService?.getUserType()) &&
  //   membership?.membershipStatus === planStatus?.INCOMPLETED &&
  //   authService?.getUser()?.type === userType?.INTERNO
  // ) {
  //   return null;
  // }

  // Admin Aux cant see affiliation card
  if (
    [salesRoles?.SALES_ADMIN_AUX].includes(authService?.getUserType()) &&
    membership?.membershipStatus === planStatus?.INCOMPLETED
  ) {
    return null;
  }

  const isACounterUserAndIntermediaryCampaign = () => {
    return authService?.getUserType() === salesRoles?.SALES_COUNTER && membership?.transferTo && membership?.membershipStatus === planStatus?.TO_BE_RENEW;
  }

  return (
    <>
      <LoadSpinner show={isLoading} />
      {[salesRoles.SALES_ADMIN].includes(authService?.getUserType()) &&
        membership?.membershipStatus === planStatus?.TO_BE_RENEW && (
          <TransferToIntermediaryModal
            show={showIntermediaryModal}
            handleModal={setShowIntermediaryModal}
            membership={membership}
            register={register}
            saleChannelOptions={salesChannelOptions}
            sellerOptions={externalSellerOptions}
            watch={watch}
            onConfirmTransfer={confirmTransferToIntermediary}
          />
        )}

      <div className="order-card">
        <OderCardHeader open={open} setOpen={setOpen} label={label} />

        {open && (
          <>
            <br />
            <div style={{ width: '100%' }} className="row">
              <div className="col-12">
                <Input
                  bootstrap={'col-12 col-md-12'}
                  label={'Comentario'}
                  type={'textarea'}
                  name={'comment'}
                  register={register}
                  placeholder={''}
                  errors={errors?.comment?.message}
                />{' '}
              </div>
              <div className="col-12 col-md-4">
                <div className="buttons-container">
                  <h6 style={{ margin: '6px 12px 12px 0px' }}>
                    DATOS DEL PLAN
                  </h6>
                </div>
                <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>

                <div className="row">
                  <Input
                    bootstrap={'col-12'}
                    label={'Tipo de afiliación '}
                    type={'text'}
                    name={'affiliationType'}
                    register={register}
                    placeholder={''}
                    errors={errors?.affiliationType?.message}
                    disabled={true}
                  />{' '}
                  <Input
                    bootstrap={'col-12'}
                    label={'Canal '}
                    type={'select'}
                    name={'saleChannel'}
                    options={salesChannelOptions}
                    register={register}
                    placeholder={''}
                    errors={errors?.saleChannel?.message}
                    disabled={isACounterUserAndIntermediaryCampaign()}
                  />{' '}
                  {[salesRoles.SALES_ADMIN].includes(authService?.getUserType()) &&
                    membership?.membershipStatus === planStatus?.TO_BE_RENEW && (
                      <IntermediaryTransferTrigger
                        sellerOptions={sellerOptions}
                        transferTo={transferTo}
                        onOpenIntermediaryModal={() => setShowIntermediaryModal(true)}
                        onClearTransferTo={clearTransferTo}
                      />
                    )}

                  <Input
                    bootstrap={'col-12'}
                    label={'Tipo de contrato '}
                    type={'text'}
                    name={'contractType'}
                    register={register}
                    placeholder={''}
                    errors={errors?.contractType?.message}
                    disabled={true}
                  />
                  <Input
                    bootstrap={'col-12'}
                    label={'Certificado Médico '}
                    type={'select'}
                    name={'useMedCert'}
                    options={[
                      { _id: true, name: 'SI' },
                      { _id: false, name: 'NO' },
                    ]}
                    register={register}
                    placeholder={''}
                    errors={errors?.useMedCert?.message}
                    // disabled={true}
                    noBlankOption={true}
                  />{' '}
                  <Input
                    bootstrap={'col-12'}
                    label={'RCV '}
                    type={'select'}
                    name={'rcv'}
                    options={rcvOptions}
                    register={register}
                    placeholder={''}
                    errors={errors?.rcvs?.message}
                    disabled={justRenovation()}
                    onChange={() => handleRCVChange()}
                  />{' '}
                  <Input
                    bootstrap={'col-12'}
                    label={'Venta de tarjeta RCV'}
                    type={'select'}
                    name={'hasRcvCard'}
                    options={[
                      { _id: true, name: 'SI' },
                      { _id: false, name: 'NO' },
                    ]}
                    register={register}
                    placeholder={''}
                    errors={errors?.hasRcvCard?.message}
                    onChange={handleTypeChange}
                    disabled={watch('rcv') === rcvEnum.NA}
                  />
                  <Input
                    bootstrap={'col-12'}
                    label={'Tipo de Plan '}
                    type={'select'}
                    name={'code'}
                    options={membershipOptions}
                    register={register}
                    placeholder={''}
                    errors={errors?.code?.message}
                    onChange={handleTypeChange}
                    disabled={validatePlanType(membership?.membershipStatus)}
                  />
                  <Input
                    bootstrap={'col-12'}
                    label={'Km de servicio de grúa'}
                    type={'select'}
                    name={'km'}
                    options={filterKmOptions(KMOderOptions)}
                    register={register}
                    placeholder={''}
                    errors={errors?.code?.km}
                    disabled={
                      ![
                        salesRoles.SALES_ADMIN,
                        salesRoles.SALES_SUPERVISOR,
                      ].includes(authService?.getUserType()) &&
                      !canEditRenewalTemplate()
                    }
                  />
                  {planAllowsUnlimitedTow(membership?.membershipPlan) && (
                    <Input
                      bootstrap={'col-12'}
                      subLabel={getUnlimitedTowLabel(getRulesDate())}
                      type={'checkbox'}
                      name={'useExtendedTow'}
                      // options={filterKmOptions(KMOderOptions)}
                      register={register}
                      placeholder={''}
                      errors={errors?.code?.useExtendedTow}
                      disabled={
                        !canEditRenewalTemplate() &&
                        (filterById(
                          membershipOptions,
                          [planTypes?.GOLD, planTypes?.GOLDM].includes(
                            watch('code')
                          )?.name
                        ) ||
                          ![salesRoles.SALES_ADMIN].includes(
                            authService?.getUserType()
                          ))
                      }
                    />
                  )}
                  <Input
                    bootstrap={'col-12'}
                    label={'Asesor '}
                    type={'select'}
                    name={'seller'}
                    options={sellerOptions}
                    register={register}
                    placeholder={''}
                    errors={errors?.seller?.message}
                    disabled={justAdminAndSupervisor()}
                  />{' '}
                  <Input
                    bootstrap={'col-12'}
                    label={'Acción de campañas '}
                    type={'select'}
                    options={campaignActionOptions}
                    capitalizeOff={true}
                    name={'campaignAction'}
                    register={register}
                    placeholder={''}
                    errors={errors?.campaignAction?.message}
                  />
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="buttons-container">
                  <h6 style={{ margin: '6px 12px 12px 0px' }}>
                    FECHAS ASOCIADAS
                  </h6>
                  <ActionButton
                    disabled={!affiliationOptionsLoaded}
                    label={'Guardar'}
                    action={editMembership}
                  />
                </div>
                <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>

                <div className="row">
                  {watch('endDateFromLastMembership') && (
                    <Input
                      bootstrap={'col-12'}
                      label={'Fin de la ultima Membresia'}
                      type={'date'}
                      name={'endDateFromLastMembership'}
                      register={register}
                      placeholder={''}
                      control={control}
                      errors={errors2?.endDateFromLastMembership?.message}
                      disabled={true}
                    />
                  )}
                  {watch('rcvEndDateFromLastMembership') && (
                    <Input
                      bootstrap={'col-12'}
                      label={'Fin del ultimo RCV'}
                      type={'date'}
                      name={'rcvEndDateFromLastMembership'}
                      register={register}
                      placeholder={''}
                      control={control}
                      errors={errors2?.rcvEndDateFromLastMembership?.message}
                      disabled={true}
                    />
                  )}
                  <Input
                    bootstrap={'col-12'}
                    label={'Fecha de creación'}
                    type={'date'}
                    name={'createdAt'}
                    register={register}
                    placeholder={''}
                    control={control}
                    errors={errors2?.createdAt?.message}
                    disabled={validateCreationDate()}
                    minDate={determinValidDate()}
                    onChange={handleCreationDateChange}
                  />
                  <Input
                    bootstrap={'col-12'}
                    label={'Inicio del Plan'}
                    type={'date'}
                    name={'beginDate'}
                    register={register}
                    placeholder={''}
                    control={control}
                    errors={errors2?.beginDate?.message}
                    disabled={validateDisabled()}
                  />
                  <Input
                    bootstrap={'col-12'}
                    label={'Fin del Plan'}
                    type={'date'}
                    name={'endDate'}
                    register={register}
                    placeholder={''}
                    control={control}
                    errors={errors2?.endDate?.message}
                    disabled={validateDisabled()}
                  />
                  <Input
                    bootstrap={'col-12'}
                    label={'Fecha de emisión RCV'}
                    type={'date'}
                    name={'rcvEmissionDate'}
                    register={register}
                    placeholder={''}
                    control={control}
                    errors={errors2?.rcvEmissionDate?.message}
                    disabled={validateDisabled()}
                  />
                  <Input
                    bootstrap={'col-12'}
                    label={'Inicio RCV'}
                    type={'date'}
                    name={'rcvBeginDate'}
                    register={register}
                    placeholder={''}
                    control={control}
                    errors={errors2?.rcvBeginDate?.message}
                    disabled={validateDisabled('rcvBeginDate')}
                  />
                  <Input
                    bootstrap={'col-12'}
                    label={'Fin RCV'}
                    type={'date'}
                    name={'rcvEndDate'}
                    register={register}
                    placeholder={''}
                    control={control}
                    errors={errors2?.rcvEndDate?.message}
                    disabled={validateDisabled('rcvEndDate')}
                  />
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="buttons-container">
                  <h6 style={{ margin: '6px 12px 12px 0px' }}>
                    DATOS DEL PAGO
                  </h6>
                </div>
                {!membership?.fleetLoad && (
                  <>
                    <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
                    <div className="row">
                      <Input
                        bootstrap={'col-12'}
                        label={'Estatus de Pago *'}
                        type={'text'}
                        name={'paymentStatus'}
                        register={register2}
                        placeholder={''}
                        errors={errors2?.paymentStatus?.message}
                        onChange={changePaymentType}
                        disabled={true}
                      />{' '}
                      <Input
                        bootstrap={'col-12'}
                        label={'Tipo de pago *'}
                        type={'select'}
                        options={allPaymentTypesOptions}
                        name={'paymentType'}
                        register={register2}
                        placeholder={''}
                        errors={errors2?.paymentType?.message}
                        onChange={changePaymentType}
                        disabled={
                          [
                            planStatus.PENDING_FOR_APPROBAL,
                            planStatus.WAITING,
                            planStatus.TO_BE_EXPIRED,
                          ].includes(membership.membershipStatus)
                            ? ![
                              salesRoles.SALES_ADMIN,
                              salesRoles.SALES_ADMIN_AUX,
                            ].includes(authService?.getUserType()) ||
                            ![
                              planStatus?.INCOMPLETED,
                              planStatus?.PENDING_FOR_APPROBAL,
                              planStatus?.WAITING,
                              planStatus?.WAITING,
                              'ESPERANDO VENCIMIENTO',
                            ].includes(membership?.membershipStatus)
                            : membership?.membershipStatus !== 'INCOMPLETO'
                        }
                      />{' '}
                      {membership?.membershipStatus ===
                        planStatus?.INCOMPLETED && (
                          <>
                            <Input
                              bootstrap={'col-12'}
                              label={'Costo del plan USD *'}
                              type={'number'}
                              name={'finalPrice'}
                              register={register2}
                              placeholder={''}
                              onChange={handleBsAmount}
                              errors={errors2?.finalPrice?.message}
                              min={0}
                              disabled={
                                ![salesRoles.SALES_ADMIN].includes(
                                  authService?.getUserType()
                                )
                              }
                            />
                            <Input
                              bootstrap={'col-12'}
                              label={'Costo del plan BsS *'}
                              type={'number'}
                              name={'finalPriceInBsS'}
                              register={register2}
                              placeholder={''}
                              errors={errors2?.finalPriceInBsS?.message}
                              min={0}
                              disabled={
                                ![salesRoles.SALES_ADMIN].includes(
                                  authService?.getUserType()
                                )
                              }
                            />
                            <Input
                              bootstrap={'col-12'}
                              label={'Fecha de Pago *'}
                              type={'birthday'}
                              name={'paymentDate'}
                              register={register2}
                              control={control2}
                              placeholder={''}
                              errors={errors2?.paymentDate?.message}
                              onChange={() => getPaymentDateRate()}
                              disabled={[
                                salesRoles.RCV,
                                salesRoles.SALES_MARKETING,
                                salesRoles.SALES_ADMIN_AUX,
                                salesRoles.SALES_RCV_SCORP,
                              ].includes(authService?.getUserType())}
                            />
                          </>
                        )}
                      {/* ![paymentType?.CASHEA, paymentType?.FINANCIADO]?.includes(membership?.paymentType) && */}
                      {membership?.membershipStatus === 'INCOMPLETO' ||
                        ([planStatus.PENDING_FOR_APPROBAL].includes(
                          membership?.membershipStatus
                        ) &&
                          user.type === 'Interno' &&
                          [
                            salesRoles.SALES_DEVELOPER,
                            salesRoles.SALES_ADMIN,
                            salesRoles.SALES_SUPERVISOR,
                            salesRoles.SALES_ADMIN_AUX,
                            salesRoles.SALES_HUNTER,
                            salesRoles.SALES_FARMER,
                            salesRoles.SALES_COUNTER,
                            salesRoles.SALES_KEY_ACCOUNTS,
                          ].includes(user.roles[0].code) && (
                            <>
                              {!membership?.giftcardCode &&
                                !membership?.discountCode && (
                                  <>
                                    <Input
                                      bootstrap={'col-8'}
                                      label={'Código (Descuento o Tarjeta)'}
                                      type={'text'}
                                      name={'code'}
                                      register={register2}
                                      placeholder={''}
                                      errors={errors2?.code?.message}
                                      min={0}
                                    />
                                    <Input
                                      bootstrap={'col-4'}
                                      label={''}
                                      type={'text'}
                                      name={'discountByCode'}
                                      register={register2}
                                      placeholder={''}
                                      errors={errors2?.discountByCode?.message}
                                      min={0}
                                      disabled={true}
                                    />
                                  </>
                                )}

                              {membership?.discountCode && (
                                <>
                                  <Input
                                    bootstrap={'col-8'}
                                    label={'Código (Descuento)'}
                                    type={'text'}
                                    name={'code'}
                                    register={register2}
                                    placeholder={''}
                                    errors={errors2?.code?.message}
                                    min={0}
                                    disabled={membership?.discountCode}
                                  />
                                  <Input
                                    bootstrap={'col-4'}
                                    label={''}
                                    type={'text'}
                                    name={'discountByCode'}
                                    register={register2}
                                    placeholder={''}
                                    errors={errors2?.discountByCode?.message}
                                    min={0}
                                    disabled={true}
                                  />
                                </>
                              )}

                              {membership?.giftcardCode && (
                                <>
                                  <Input
                                    bootstrap={'col-8'}
                                    label={'Código (Tarjeta)'}
                                    type={'text'}
                                    name={'giftcardCode'}
                                    register={register2}
                                    placeholder={''}
                                    errors={errors2?.giftcardCode?.message}
                                    min={0}
                                    disabled={membership?.giftcardCode}
                                  />
                                  <Input
                                    bootstrap={'col-4'}
                                    label={''}
                                    type={'text'}
                                    name={'discountByGiftcard'}
                                    register={register2}
                                    placeholder={''}
                                    errors={
                                      errors2?.discountByGiftcard?.message
                                    }
                                    min={0}
                                    disabled={true}
                                  />
                                </>
                              )}
                            </>
                          ))}
                      {!membership?.discountCode &&
                        !membership?.giftcardCode && (
                          <>
                            {[planStatus.INCOMPLETED].includes(
                              membership?.membershipStatus
                            ) ? (
                              <div className="buttons-center-container">
                                <ActionButton
                                  label={'Aplicar código'}
                                  action={applyDiscount}
                                />
                              </div>
                            ) : (
                              <>
                                {[planStatus.PENDING_FOR_APPROBAL].includes(
                                  membership?.membershipStatus
                                ) &&
                                  user.type === 'Interno' &&
                                  [
                                    salesRoles.SALES_DEVELOPER,
                                    salesRoles.SALES_ADMIN,
                                    salesRoles.SALES_SUPERVISOR,
                                    salesRoles.SALES_ADMIN,
                                    salesRoles.SALES_HUNTER,
                                    salesRoles.SALES_FARMER,
                                    salesRoles.SALES_COUNTER,
                                    salesRoles.SALES_KEY_ACCOUNTS,
                                  ].includes(user.roles[0].code) ? (
                                  <div className="buttons-center-container">
                                    <ActionButton
                                      label={'Aplicar código'}
                                      action={applyDiscount}
                                    />
                                  </div>
                                ) : null}
                              </>
                            )}
                          </>
                        )}
                      {(membership?.discountCode ||
                        membership?.giftcardCode) && (
                          <>
                            {[planStatus.INCOMPLETED].includes(
                              membership?.membershipStatus
                            ) ? (
                              <div className="buttons-center-container">
                                <ActionButton
                                  label={'Remover código'}
                                  action={removeDiscount}
                                />
                              </div>
                            ) : [planStatus.PENDING_FOR_APPROBAL].includes(
                              membership?.membershipStatus
                            ) &&
                              user.type === 'Interno' &&
                              [
                                salesRoles.SALES_DEVELOPER,
                                salesRoles.SALES_ADMIN,
                                salesRoles.SALES_ADMIN,
                                salesRoles.SALES_SUPERVISOR,
                                salesRoles.SALES_HUNTER,
                                salesRoles.SALES_FARMER,
                                salesRoles.SALES_COUNTER,
                                salesRoles.SALES_KEY_ACCOUNTS,
                              ].includes(user.roles[0].code) ? (
                              <div className="buttons-center-container">
                                <ActionButton
                                  label={'Remover código'}
                                  action={removeDiscount}
                                />
                              </div>
                            ) : null}
                          </>
                        )}
                      {membership?.membershipStatus !== 'INCOMPLETO' && (
                        <>
                          {watch2('discountCode') && (
                            <>
                              <Input
                                bootstrap={'col-12 col-md-6'}
                                label={'Descuento'}
                                type={'text'}
                                name={'discountCode'}
                                register={register2}
                                placeholder={''}
                                errors={errors2?.discountCode?.message}
                                disabled={
                                  membership?.membershipStatus !== 'INCOMPLETO'
                                }
                              />
                              <Input
                                bootstrap={'col-12 col-md-6'}
                                label={''}
                                type={'text'}
                                name={'discountByCode'}
                                register={register2}
                                placeholder={''}
                                errors={errors2?.discountByCode?.message}
                                disabled={
                                  membership?.membershipStatus !== 'INCOMPLETO'
                                }
                              />
                            </>
                          )}
                          {watch2('giftcardCode') && (
                            <>
                              <Input
                                bootstrap={'col-12 col-md-6'}
                                label={'Tarjeta'}
                                type={'text'}
                                name={'giftcardCode'}
                                register={register2}
                                placeholder={''}
                                errors={errors2?.giftcardCode?.message}
                                disabled={
                                  membership?.membershipStatus !== 'INCOMPLETO'
                                }
                              />
                              <Input
                                bootstrap={'col-12 col-md-6'}
                                label={''}
                                type={'text'}
                                name={'discountByGiftcard'}
                                register={register2}
                                placeholder={''}
                                errors={errors2?.discountByGiftcard?.message}
                                disabled={
                                  membership?.membershipStatus !== 'INCOMPLETO'
                                }
                              />
                            </>
                          )}
                        </>
                      )}
                      <h6>
                        Nivel de Siniestralidad: {membership?.accidentRate}
                      </h6>
                      <h6>
                        Cantidad de Servicios de Grua:{' '}
                        {membership?.towServices?.length}
                      </h6>
                      <br />
                      {/* {membership?.paymentType === paymentType?.PENDING &&
                        membership?.paymentStatus !== 'Pago realizado' && (
                          <ActionButton
                            label={'Realizar pago pendiente'}
                            action={openMembershipPendingPaymentModal}
                          />
                        )} */}
                    </div>
                    {validateIfCanPay()}

                    {/* {
                      watch2('paymentType') === paymentType?.FINANCIADO && (
                        <FinancedPaymentForm
                          membership={membership}
                          register2={register2}
                          errors2={errors2}
                          watch2={watch2}
                          options={{ paymentMethods: paymentMethods }}
                          action={openMembershipPendingPaymentModal}
                          editPendingPayment={editPendingPayment}
                          handleDueAmountChange={handleDueAmountChange}
                        />
                      )
                    } */}
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export const FinancedPaymentForm = (props) => {
  const {
    membership,
    register2,
    errors2,
    watch2,
    options,
    action,
    editPendingPayment,
    handleDueAmountChange = { handleDueAmountChange },
  } = props;

  const getPaymentsRef = (membership, i) => {
    let selectedRef = membership?.payments?.filter(
      (p) => p?._id === membership?.paymentDues[i]?.payment[0]
    );

    if (selectedRef?.length > 0) {
      return (
        <div className="row">
          <Input
            bootstrap={'col-6'}
            label={'Referencia'}
            type={'text'}
            options={options?.paymentMethods}
            name={`paymentDues[${i}].reference`}
            register={register2}
            placeholder={''}
            errors={errors2?.[`paymentDues[${i}].reference`]?.message}
            disabled={allowEditPayment()}
          />
          <div className="col-6">
            <div className="ref-image-container">
              {selectedRef[0]?.referenceImg && (
                <a
                  target="_blank"
                  href={selectedRef[0]?.referenceImg}
                  rel="noreferrer"
                >
                  <h6>Ver Comprobante</h6>
                </a>
              )}
            </div>
          </div>
          {allowAdmin && (
            <div style={{ marginBottom: '12px' }} className="col-6">
              <ActionButton
                label={'Editar Pago'}
                action={() => editPendingPayment(i)}
              />
            </div>
          )}
        </div>
      );
    } else return null;
  };

  if (membership?.paymentDues?.length > 0) {
    return (
      <>
        {membership?.paymentDues?.map((m, i) => (
          <div className="row">
            <div className="light-gray-line"></div>
            <h6>
              Cuota ({i + 1}){' '}
              {membership?.paymentDues[i].dueDate
                ? moment(membership?.paymentDues[i].dueDate).format(
                  'DD/MM/YYYY'
                )
                : ''}
            </h6>
            <Input
              bootstrap={'col-6'}
              label={'Monto'}
              type={'number'}
              name={`paymentDues[${i}].amount`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].amount`]?.message}
              min={1}
              max={2}
              onChange={handleDueAmountChange(
                watch2(`paymentDues[${i}].amount`),
                watch2(`paymentDues[${i}].payment`),
                i
              )}
              disabled={allowEditPayment()}
            />{' '}
            <Input
              bootstrap={'col-6'}
              label={'Monto bolivares'}
              type={'number'}
              name={`paymentDues[${i}].amountBs`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].amountBs`]?.message}
              min={1}
              max={2}
              disabled={allowEditPayment()}
            />
            <Input
              bootstrap={'col-6'}
              label={'Metodo de Pago'}
              type={'select'}
              options={options?.paymentMethods}
              name={`paymentDues[${i}].paymentMethod`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].paymentMethod`]?.message}
              disabled={allowEditPayment()}
            />{' '}
            <Input
              bootstrap={'col-6'}
              label={'Estatus de Pago'}
              type={'text'}
              options={options?.paymentMethods}
              name={`paymentDues[${i}].payment`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].payment`]?.message}
              disabled={true}
            />
            {getPaymentsRef(membership, i)}
            <Input
              bootstrap={'col-6'}
              label={'Fecha de Pago'}
              type={'text'}
              options={options?.paymentMethods}
              name={`paymentDues[${i}].paymentDate`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].paymentDate`]?.message}
            />
            <Input
              bootstrap={'col-6'}
              label={'Fecha de Corte'}
              type={'text'}
              options={options?.paymentMethods}
              name={`paymentDues[${i}].dueDate`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].dueDate`]?.message}
              disabled={true}
            />
            {(m?.payment?.length === 0 || !m?.payment) && (
              <ActionButton label={'Realizar pago pendiente'} action={action} />
            )}
            <br />
          </div>
        ))}
      </>
    );
  } else return null;
};
